$(function(){
	"use strict";
	
	if($('#intro_section video').length>0){
		
		//$('.bgvid').coverVid(1920, 1080);

		/*var check_video_size = function() {
				var vid = $("video");
				var section = $(vid).parents('section').first();

				$(section).height($(window).height());
				var section_height = $(section).height();
				var section_width = $(section).width();

				if ($(vid).height() < $(section).height()) {
					$(vid).css({
						'width': 'auto',
						'height': '120%'
					});
				}
				if ($(vid).width() < $(section).width()) {
					$(vid).css({
						'width': '120%',
						'height': 'auto'
					});
				}
				// Center the video
				var vid_height = $(vid).height();
				var vid_width = $(vid).width();
				if (vid_height > section_height) {
					var offset = (vid_height - section_height) / 2 * -1;
					$(vid).css({
						'top': offset + 'px'
					});
				}
				if (vid_width > section_width) {
					var offset = (vid_width - section_width) / 2 * -1;
					$(vid).css({
						'left': offset + 'px'
					});
				}
			};
		check_video_size();
		$(window).on("resize", check_video_size);
		*/
	}
});